import React from "react";
import Eyebrow from "./Eyebrow";

const models = [
  {
    number: "01",
    title: "In-class learning",
    desc:
      "Place employees into scheduled Utiva programmes with an active learner community.",
  },
  {
    number: "02",
    title: "Exclusive team training",
    desc:
      "Deliver an existing Utiva course privately for your team and preferred format.",
  },
  {
    number: "03",
    title: "Custom content",
    desc:
      "Co-create a programme around your capability gaps, business context and strategic goals.",
  },
];

const EngagementModelsSection = () => {
  return (
    <section
      className="py-[78px] lg:py-[105px] px-[18px] sm:px-[max(26px,50vw-640px)]"
      id="corporate-training-approach"
    >
      <div className="grid grid-cols-1 lg:grid-cols-mba-heading items-end gap-5 lg:gap-20 mb-12">
        <div>
          <Eyebrow>THREE WAYS TO ENGAGE</Eyebrow>
          <h2 className="text-primary tracking-[-0.045em] m-0 text-[36px] font-bold sm:text-corp-h2 leading-[1.12]">
            Choose the training model your organisation needs.
          </h2>
        </div>
        <p className="text-[#555b6e] m-0 text-[17px] leading-[1.8]">
          Start with a proven programme or build a custom capability journey
          around your goals.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[15px]">
        {models.map((model) => (
          <article
            key={model.title}
            className="flex flex-col border border-[#dce4f5] bg-white rounded-[22px] min-h-[280px] sm:min-h-[320px] p-[29px] shadow-corp-card"
          >
            <span className="text-[#9a6500] tracking-[0.05em] text-sm font-850">
              {model.number}
            </span>
            <h3 className="text-primary tracking-[-0.025em] font-bold mt-auto mb-3 text-2xl leading-[1.28]">
              {model.title}
            </h3>
            <p className="text-[#555b6e] m-0 text-base leading-[1.72]">
              {model.desc}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default EngagementModelsSection;
